import { PartialTranslation } from '../translations';

export const ro: PartialTranslation = {
  newChat: 'Chat nou',
  search: 'Căutare',
  user: 'Utilizator',
  settings: 'Setări',
  language: 'Limba',
  getHelp: 'Obține ajutor',
  viewAllPlans: 'Vezi toate planurile',
  learnMore: 'Află mai multe',
  logOut: 'Deconectare',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Detectare automată',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Întreabă orice',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personal',
  freePlan: 'Plan gratuit',
  current: 'Actual',
  close: 'Închide',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Resurse',
  addResource: 'Adaugă resursă',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Scrie un mesaj...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Adaugă anexă',
  sendMessage: 'Trimite mesaj',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Conectare',
  register: 'Înregistrare',
  welcomeBack: 'Bun venit la LawHelper',
  loginSubtitle: 'Asistentul AI pentru Cercetare Juridică',
  continueWithGoogle: 'Continuă cu Google',
  continueWithMicrosoft: 'Continuă cu Microsoft',
  continueWithWeChat: 'Continuă cu WeChat',
  orContinueWith: 'sau continuă cu',
  emailTab: 'Email',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Introduceți emailul',
  phonePlaceholder: 'Introduceți numărul de telefon',
  codePlaceholder: 'Introduceți codul din 6 cifre',
  sending: 'Se trimite...',
  verifying: 'Se verifică...',
  verify: 'Verificare',
  sendMagicLink: 'Trimite link magic',
  getVerificationCode: 'Obține codul',
  resendCode: 'Retrimite codul',
  resendIn: 'Retrimite în',
  magicLinkSent: 'Link magic trimis la emailul dvs.',
  magicLinkHint: 'Vom trimite un link securizat la emailul dvs.',
  otpSent: 'Cod de verificare trimis',
  agreeToTerms: 'Continuând, sunteți de acord cu',
  privacyPolicy: 'Politica de confidențialitate',
  termsOfService: 'Termeni și condiții',
  and: 'și',
  privacyTitle: 'Confidențialitatea dvs. contează',
  privacyIntro: 'Folosim cookie-uri și tehnologii similare pentru a vă oferi cea mai bună experiență.',
  essentialCookies: 'Cookie-uri esențiale',
  essentialDesc: 'Necesare pentru funcționarea site-ului',
  analyticsCookies: 'Cookie-uri analitice',
  analyticsDesc: 'Ne ajută să îmbunătățim serviciul',
  marketingCookies: 'Cookie-uri de marketing',
  marketingDesc: 'Folosite pentru conținut personalizat',
  acceptAll: 'Acceptă toate',
  essentialOnly: 'Doar esențiale',
  customize: 'Personalizare',
  savePreferences: 'Salvează preferințele',
  back: 'Înapoi',
  readPrivacyPolicy: 'Citiți politica noastră de confidențialitate',
  cookiePolicy: 'Politica cookie-urilor',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Verificare AI',
  aiDraft: 'Schiță AI',
  smartAssistant: 'Șablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Activare căutare',
  knowledgeSearchDesc: 'AI caută în documentele dvs.',
  clickToDisable: 'Dezactivare',
  clickToEnable: 'Activare',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Închide panoul de resurse',
  uploading: 'Se încarcă %{fileName}...',
  processing: 'Se procesează %{fileName}...',
  uploadSuccess: '✓ %{fileName} încărcat',
  uploadError: '✗ Încărcare eșuată: %{error}',
  quickAnswer: 'Răspuns rapid',
  quickAnswerDesc: 'Răspuns rapid la întrebări simple',
  cancelRequest: 'Anulează',
  library: 'Bibliotecă',
  filterAll: 'Toate',
  filterChat: 'Conversații',
  filterReview: 'Revizuire',
  filterDraft: 'Ciornă',
  filterTemplate: 'Șablon',
  filterForm: 'Formular',
  thinking: 'Gândesc...',
  thinkingProcess: 'Procesul de gândire',
  analyzingLegalLogic: 'Analizez logica juridică...',
  lawhelperThinking: 'Lawhelper gândește...',
  serviceError: 'Eroare de serviciu',
  uploaded: 'Încărcat',
  settingsGeneral: 'General',
  settingsNotifications: 'Notificări',
  settingsAppearance: 'Aspect',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Notificări răspuns',
  settingsResponseNotificationsDesc: 'Notificare la finalizarea răspunsului AI',
  settingsColorMode: 'Mod culoare',
  settingsLight: 'Deschis',
  settingsDark: 'Întunecat',
  settingsSystem: 'Sistem',
  about: 'Despre',
  reviewTitle: 'Revizuire document',
  exitReview: 'Ieși din revizuire',
  uploadPrompt: 'Încarcă PDF pentru revizuire',
  uploadButton: 'Selectează fișier',
  startChatConfig: 'Scrie "Revizuiește acest document"',
  reviewPlaceholder: 'Scrie un mesaj...',
  analyzing: 'Se revizuiește...',
  reviewComplete: 'Revizuire finalizată',
  issuesFound: '%{count} probleme găsite',
  draftTitle: 'Redactare document juridic',
  draftPlaceholder: 'Editează aici sau cere AI-ului să genereze...',
  analyzingTemplate: 'Se analizează șablonul %{name}...',
  templateAnalyzed: '✅ Șablon %{name} analizat!',
  templateAnalysisPrompt: 'Analizează clauzele cheie',
  parsingFailed: '⚠️ Fișierul nu a putut fi analizat.',
  generating: 'Se generează...',
  generatedSuccess: '✅ Document generat!',
  drafterWelcome: 'Bun venit la Asistentul AI pentru documente',
  drafterYouCan: 'Poți:',
  drafterUploadTemplate: 'Încărca un șablon pentru analiză AI',
  drafterDescribeNeeds: 'Descrie cerințele documentului',
  drafterLetAiHelp: 'AI te ajută cu contracte, acorduri etc.',
  drafterExamples: 'Exemple:',
  drafterExampleRental: '"Redactează un contract de închiriere"',
  drafterExampleLabor: '"Completează contractul de muncă"',
  drafterInputPlaceholder: 'Descrie nevoile tale...',
  drafterThinking: 'Gândesc...',
  drafterHistoryTitle: 'Istoric',
  drafterNoHistory: 'Niciun istoric',
  drafterNewChat: 'Conversație nouă',
  drafterHistory: 'Istoric',
  drafterRemoveAttachment: 'Elimină atașament',
  drafterLineHeight: 'Înălțime rând',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export ca Word (.docx)',
  drafterExportPdf: 'Export ca PDF',
  drafterSave: 'Salvează document',
  drafterDownload: 'Descarcă document',
  drafterUndo: 'Anulează',
  drafterRedo: 'Refă',
  drafterBold: 'Îngroșat',
  drafterItalic: 'Italic',
  drafterStrike: 'Tăiat',
  drafterUnderline: 'Subliniat',
  drafterHighlight: 'Evidențiere',
  drafterLink: 'Inserare link',
  drafterAlignLeft: 'Aliniere stânga',
  drafterAlignCenter: 'Centrare',
  drafterAlignRight: 'Aliniere dreapta',
  drafterAlignJustify: 'Justificare',
  drafterList: 'Listă',
  drafterBulletList: 'Listă cu marcatori',
  drafterOrderedList: 'Listă numerotată',
  drafterTaskList: 'Listă de sarcini',
  drafterOpenResource: 'Deschide panoul de resurse',
  drafterStopGeneration: 'Oprește generarea',
  drafterAgentMode: 'Mod agent activ',
  drafterAgentModeOn: 'Mod agent activ',
  drafterAgentModeOff: 'Mod normal',
  drafterUploadAttachment: 'Încarcă atașament',
  drafterExit: 'Ieși',
  drafterConfirm: 'Confirmă',
  drafterOpenLink: 'Deschide link',
  drafterDeleteLink: 'Șterge link',
  drafterQuote: 'Citat',
  workflowTitle: 'Flux AI',
  workflowRunning: 'În execuție...',
  workflowReady: 'Pregătit',
  workflowCompleted: 'Finalizat',
  workflowStartFailed: 'Pornirea fluxului a eșuat',
  workflowExecutionFailed: 'Execuția fluxului a eșuat',
  workflowInterrupted: 'Flux întrerupt',
  workflowProcessing: 'Se procesează...',
  workflowStepsCompleted: 'pași finalizați',
  workflowStepsTotal: 'Flux finalizat (%{count} pași)',
  acceptChanges: 'Acceptă modificări',
  rejectChanges: 'Respinge modificări',
  changesAccepted: 'Modificări acceptate',
  changesRejected: 'Modificări respinse',
  stopWorkflow: 'Oprește',
  restartWorkflow: 'Repornește',
  startDrafting: 'Începe redactarea',
  interrupt: 'Oprește',
  documentSubject: 'Subiect document *',
  documentType: 'Tip document',
  jurisdiction: 'Jurisdicție',
  specialRequirements: 'Cerințe speciale (opțional)',
  clickStartDrafting: 'Apasă "Începe redactarea"',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Acord',
  docTypeNotice: 'Notificare',
  docTypeLetter: 'Scrisoare',
  docTypePetition: 'Petiție',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Procură',
  countryChina: 'China',
  countryUSA: 'SUA',
  countryGermany: 'Germania',
  countryJapan: 'Japonia',
  countryFrance: 'Franța',
  countryUK: 'Regatul Unit',
  citationVerified: 'Verificat',
  citationUnverified: 'Neverificat',
  imageLoadFailed: 'Imaginea nu a putut fi încărcată',
  smartDocTitle: 'Asistent inteligent documente',
  smartDocChatTitle: 'Asistent AI documente',
  smartDocDropPrompt: 'Trage fișierul PDF aici',
  smartDocSelectFile: 'Selectează fișier',
  smartDocOr: 'sau',
  smartDocWelcomeTitle: 'Bun venit la Asistentul AI',
  smartDocWelcomeYouCan: 'Poți:',
  smartDocUploadForAI: 'Încărca șablon',
  smartDocDescribeDoc: 'Descrie cerințele',
  smartDocLetAIDraft: 'AI ajută cu contracte',
  smartDocExamples: 'Exemple:',
  smartDocExampleRental: '"Redactează un contract de închiriere"',
  smartDocExampleLabor: '"Completează contractul de muncă"',
  smartDocInputPlaceholder: 'Descrie nevoile...',
  smartDocRemoveAttachment: 'Elimină atașament',
  smartDocOpenResources: 'Deschide resurse',
  smartDocExit: 'Ieși',
  reviewStartFailed: 'Pornirea revizuirii a eșuat',
  reviewFailed: 'Revizuire eșuată',
  reviewFoundIssues: 'Revizuire finalizată, %{count} probleme.',
  cannotReadStream: 'Nu se poate citi fluxul',
  parseEventFailed: 'Analiza evenimentului a eșuat',
  errorPrefix: 'Eroare',
  unknownError: 'Eroare necunoscută',
  file: 'Fișier',
  loading: 'Se încarcă...',
  localFolders: 'Dosare locale',
  selectLocalFolder: 'Selectează dosar local',
  reselectFolder: 'Schimbă dosar',
  addToContext: 'Adaugă la conversație',
  saveFile: 'Salvează',
  renameFile: 'Redenumește',
  fileSaved: 'Fișier salvat',
  fileRenamed: 'Fișier redenumit în %{name}',
  browserNotSupported: 'Browserul nu suportă accesul la dosare',
  noFolderSelected: 'Selectează un dosar local',
  scanningFolder: 'Se scanează dosarul...',
  selectFileToPreview: 'Selectează fișier pentru previzualizare',
  aiAnalyze: 'Analiză AI',
};
